module.exports = __webpack_public_path__ + "static/question-mark-circle.1bc7c141848637b42e3e0470fb51d43c.svg";